import { JobSecurityRight } from '../../security/modules/job.security.module';
import { CrmSecurityRight } from '../../security/modules/crm.security.module';
import { QuoteSecurityRight } from '../../security/modules/quote.security.module';
import { SalesSecurityRight } from '../../security/modules/sales.security.module';
import { ActivityEntityName } from '../shared/activity.entity.name';

export const NotificationEntityRights = Object.freeze({
    [ActivityEntityName.Job]: [JobSecurityRight.CanAccess],
    [ActivityEntityName.WorkOrder]: [JobSecurityRight.CanAccess],
    [ActivityEntityName.Work]: [JobSecurityRight.CanAccess],
    [ActivityEntityName.Customer]: [CrmSecurityRight.CanAccess],
    [ActivityEntityName.Supplier]: [CrmSecurityRight.CanAccess],
    [ActivityEntityName.Employee]: [CrmSecurityRight.CanAccess],
    [ActivityEntityName.Contractor]: [CrmSecurityRight.CanAccess],
    [ActivityEntityName.ContactInvite]: [CrmSecurityRight.CanAccess],
    [ActivityEntityName.LoginContact]: [CrmSecurityRight.CanAccess],
    [ActivityEntityName.QuotePro]: [QuoteSecurityRight.CanAccess],
    [ActivityEntityName.Lead]: [SalesSecurityRight.CanAccessLeads],
    [ActivityEntityName.Opportunity]: [SalesSecurityRight.CanAccessOpportunities]
})
